define('notifications_order_promocodes.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications_order_promocodes', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Promocode.Notification\"></div>  ";
},"useData":true}, 'extensions/BTM/RetailThreads/3.4.2/', 'extensions/BTM/RetailThreads/3.4.2/', Handlebars);
});